// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__1v9iV","leftImage":"index_leftImage__3BM32"};